export enum GetSignedUrlUploadType {
  USER_PROFILE = 'USER_PROFILE',
  INSURANCE = 'INSURANCE',
  MESSAGES = 'MESSAGES',
  DOCUMENTS = 'DOCUMENTS',
  BULLETIN = 'BULLETIN',
  RESUME = 'RESUME',
  CDE = 'CDE',
  FEEDBACK = 'FEEDBACK',
  BLOG_WRITER = 'BLOG_WRITER',
  BLOG = 'BLOG',
  LMN = 'LMN',
  LEGAL_DOCUMENTS = 'LEGAL_DOCUMENTS',
}